import { createSlice } from '@reduxjs/toolkit';
import fetchSimilarProducts from '../thunk/similar-products-thunk';

// Initial state
const initialState = {
  items: [],
  isLoading: true,
  error: null,
  page: 1,
  limit: 10,
};

// Slice
const similarProductsSlice = createSlice({
  name: 'similar-products',
  initialState,
  reducers: {
    reset: (state) => {
      state.items = [];
      state.isLoading = true;
      state.error = null;
      state.page = 1;
      state.limit = 12;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSimilarProducts.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchSimilarProducts.fulfilled, (state, action) => {
        state.items = action.payload?.items || [];
        state.isLoading = false;
      })
      .addCase(fetchSimilarProducts.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const { reset } = similarProductsSlice.actions;

export default similarProductsSlice.reducer;
